import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["hovered"];
import { useCallback, useState } from 'react';
import emptyFunction from 'react-utils/emptyFunction';
import { View } from 'foundations-components/components/View';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import useHovered from 'UIComponents/hooks/useHovered';
import { Lightbox } from 'foundations-components/transitional/components/Lightbox';
import { Image } from 'foundations-components/transitional/components/Image';
import LightboxImage from './LightboxImage';
import { DownloadIcon } from 'foundations-assets/icons/components/DownloadIcon';
import I18n from 'I18n';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ZoomableImage = styled.div.withConfig({
  displayName: "ImageFormatter__ZoomableImage"
})(["transition:transform 0.2s ease;transform:", ";inline-size:100%;block-size:100%;"], props => props.$hovered ? 'scale(1.05)' : 'scale(1)');
const ImageFormatter = ({
  alt,
  onImageClick,
  showLightbox,
  src
}) => {
  const _useHovered = useHovered({}),
    {
      hovered
    } = _useHovered,
    hoveredProps = _objectWithoutPropertiesLoose(_useHovered, _excluded);
  const [isActive, setIsActive] = useState(false);
  const preventPropagation = useCallback(evt => {
    evt.stopPropagation();
  }, []);
  const onClose = useCallback(() => {
    setIsActive(false);
  }, []);
  const onOpen = useCallback(() => {
    if (onImageClick) {
      onImageClick(src, alt);
      return;
    }
    setIsActive(true);
  }, [alt, onImageClick, src]);
  const isClickable = showLightbox || Boolean(onImageClick);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(View, Object.assign({}, hoveredProps, {
      cursor: isClickable ? 'zoom-in' : undefined,
      onClick: isClickable ? onOpen : emptyFunction,
      position: "relative",
      children: [/*#__PURE__*/_jsx(View, {
        overflow: "hidden",
        inlineSize: "100%",
        blockSize: "100%",
        children: /*#__PURE__*/_jsx(ZoomableImage, {
          $hovered: hovered,
          children: /*#__PURE__*/_jsx(Image, {
            alt: alt,
            src: src
          })
        })
      }), hovered && /*#__PURE__*/_jsx(View, {
        position: "absolute",
        insetBlockStart: "200",
        insetInlineEnd: "200",
        children: /*#__PURE__*/_jsx("a", {
          "aria-label": I18n.text('chatspotComponents.sections.mediaSectionFormatter.downloadImage'),
          download: true,
          href: src,
          onClick: preventPropagation,
          target: "_blank",
          rel: "noreferrer",
          children: /*#__PURE__*/_jsx(IconButton, {
            size: "xs",
            use: "secondary",
            children: /*#__PURE__*/_jsx(DownloadIcon, {})
          })
        })
      })]
    })), isActive && /*#__PURE__*/_jsx(Lightbox, {
      ImageComponent: LightboxImage,
      closeable: true,
      imageSrc: src,
      onClose: onClose
    })]
  });
};
export default ImageFormatter;